import { representativesCarryingOf } from '@e-socna/folder-actors';

import { missingRequiredRoleIds } from '../../../components/Actors/utils/missing-required-roles.util';
import type { RoleActor } from '../../../components/Actors/utils/missing-required-roles.util';

// The roles the workflow requires of each internal organization, for its actor form.
export interface RoleRequirement {
  readonly requiredRoleIds: readonly string[];
  readonly enabledStatusId: string;
  readonly labelOf: (roleId: string) => string;
}

type Memberships = readonly Readonly<{
  personId: string;
  statusId: string;
  contextualRoleIds?: readonly string[] | null;
}>[];

// Why the representatives of an internal organization do not carry the required roles (their own
// roles, else the ones of their active membership): the French refusal, or null.
export const requiredRolesRefusalOf = (
  organization: Readonly<Partial<RoleActor>>,
  memberships: Memberships,
  { requiredRoleIds, enabledStatusId, labelOf }: Readonly<RoleRequirement>,
): string | null => {
  if (!requiredRoleIds.length || !organization.thirdPartyId) {
    return null;
  }

  const missingRoleIds = missingRequiredRoleIds({
    internalActors: [
      {
        kind: organization.kind ?? '',
        thirdPartyId: organization.thirdPartyId,
        representatives: organization.representatives ?? [],
      },
    ],
    organizations: [
      { _id: organization.thirdPartyId, allMemberships: memberships },
    ],
    enabledStatusId,
    requiredRoleIds,
  });

  return missingRoleIds.length
    ? `Cette organisation interne doit posséder ${representativesCarryingOf('role', missingRoleIds.map(labelOf))}.`
    : null;
};
